/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ArrowUp/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ArrowUp({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ArrowUp",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 11,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ArrowUp.Svg"
  data-view-path={viewPath}
 viewBox="0 0 11 10"
 style={{'--as-1-Z16GIOz': alignSelf,'--mt-2-Z16GIOz': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z16GIOz': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z16GIOz': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z16GIOz': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z16GIOz': opacity,'--w-10-Z16GIOz': typeof width === 'number' ? `${width}px` : width,'--h-11-Z16GIOz': typeof height === 'number' ? `${height}px` : height,'--f-12-Z16GIOz': fill,'--a-7-Z16GIOz': isAnimated ? animation : "none",'--sd-8-Z16GIOz': isAnimated ? strokeDashoffset : 0,'--sd-9-Z16GIOz': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2ArrowUp.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_2176_4001)"
 transform="rotate(-90 5.5 5)"
 className="views-block"
>
<path
  data-testid="Tysiav2ArrowUp.SvgPath"
  data-view-path={viewPath}
 d="M4.786.357a.357.357 0 01.61-.252l4.382 4.39a.7.7 0 010 1.01l-4.382 4.39a.357.357 0 01-.61-.252V.357z"
 style={{'--f-12-Z16GIOz': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}